import React from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import { useTranslateKey } from "../translation/useTranslateKey";


const ConectionModal = ({ show, onClose, isEmail }) => {
  const t = useTranslateKey();

  if (!show) return null;
  

  const handleConfirmCall = () => {
    window.location.href = isEmail
      ? "tel:+201030282513"
      : "mailto:info@ssignature.com";
  };
  return (
    <div
      className="fixed inset-0 flex items-start justify-center z-50 pt-20"
      style={{ backgroundColor: "rgba(18, 21, 37, 0.98)" }}
    >
      <div
        className="bg-[#11132F] border-2 border-[#332D7E] rounded-xl p-8 max-w-md w-full mx-4 relative shadow-2xl"
        style={{ backgroundColor: "#11132F" }}
      >
        <h3 className="text-2xl font-bold text-white mb-6">{t("contactUs")}</h3>

        <div>
          <p className="block text-[#F9C835] mb-2">
            {" "}
            {isEmail ? t("email") : t("phoneNumber")}
          </p>

          <p className="text-xl mb-6">
            {isEmail ? "info@ssignature.com" : "+20 103 028 2513"}
          </p>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="submit-filter-btn px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              {t("cancel")}
            </button>
            <button
              onClick={handleConfirmCall}
              className="px-4 py-2 bg-[#FF6B6B] text-white rounded-md hover:bg-[#e55a5a]"
            >
              {isEmail ? t("sendEmail") : t("callNow") }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConectionModal;
